if (!customElements.get("checkout-button")) {
  class CheckoutButton extends HTMLElement {
    constructor() {
      super();
      this.isCustomBundle =
        (this.dataset && this.dataset.bundle === "true") || false;
      this.container = this.closest(".checkout-button");
      this.form = this.closest("form");
      this.button = this.querySelector("[type=submit]");
      this.variantJSON = this.querySelector(
        "#free-trial-product-variants-json"
      );
      this.orderCreationPayload = {};
      this.DEFAULT_CART_ITEMS = {
        add: [],
        remove: [],
        attributes: {},
        count: 0,
      };
    }
    connectedCallback() {
      this.container = this.closest(".checkout-button");
      this.form = this.closest("form");
      this.button = this.querySelector("[type=submit]");
      this.load();
    }

    getAdditionalItems() {
      try {
        return JSON.parse(
          this.querySelector(".checkout-button__additional-items").innerHTML
        );
      } catch (error) {
        // ignore. probably no additional items
      }
      return [];
    }

    getSelectedVariantFromProductOptions() {
      let selectedVariantId = null;
      try {
        const selectedOptions = Array.from(
          this.form.querySelectorAll('[data-type="option"]:checked')
        );
        const variants = JSON.parse(this.variantJSON.innerHTML);
        const selectedVariant = variants.find((variant) => {
          return selectedOptions.every((option) => {
            const optionPosition = option.getAttribute("data-option-position");
            const optionValue = option.getAttribute("value");
            return variant[optionPosition] == optionValue;
          });
        });
        selectedVariantId = selectedVariant ? selectedVariant.id : null;
      } catch (error) {
        logger.error(error);
      }
      return selectedVariantId;
    }

    async tranformOrderItemForStorefront() {
      this.items = this.createOrderItemsFromForm().concat(
        this.getAdditionalItems()
      );
      const items = await this.appendExtraCartItemProperties({
        cartItems: this.items,
        updateCart: false,
      });
      return items.map((item) => {
        const attributes = cleanObject(item.properties);
        return {
          attributes: Object.entries(attributes).map(([key, value]) => ({
            key,
            value,
          })),
          quantity: item.quantity,
          merchandiseId: `gid://shopify/ProductVariant/${item.variant}`,
          sellingPlanId: item.selling_plan
            ? `gid://shopify/SellingPlan/${item.selling_plan}`
            : null,
        };
      });
    }

    createOrderItemsFromForm() {
      const orderItems = [];
      if (this.form) {
        const formData = new FormData(this.form);
        const variantId =
          this.getSelectedVariantFromProductOptions() || formData.get("id");
        if (variantId) {
          orderItems.push({
            quantity: formData.get("interval") || 1,
            variant: variantId,
            offerId: formData.get("properties[_offer_id]"),
            selling_plan: formData.get("selling_plan"),
            properties: {
              _item_type: formData.get("properties[_item_type]") || undefined,
            },
          });
        }
      }
      return orderItems;
    }

    // Buttons that submit the same form should all show loading status
    setLoadingForRelatedButtons(isLoading) {
      if (this.button && this.form) {
        const formId = this.form.getAttribute("id");
        Array.from(document.querySelectorAll(`[form=${formId}]`)).forEach(
          (button) => {
            isLoading
              ? button.classList.add("loading")
              : button.classList.remove("loading");
          }
        );
      }
    }

    setLoading(isLoading) {
      isLoading
        ? this.classList.add("loading")
        : this.classList.remove("loading");
      this.setLoadingForRelatedButtons(isLoading);
    }
    getAutomaticCoupons() {
      return [
        this.button.getAttribute("data-slug"),
        this.getAttribute("data-override-coupon"),
      ].filter((code) => code);
    }

    getOverrideCouponAttribute() {
      const attribute = [];
      const overrideCoupon = this.getAttribute("data-override-coupon");
      if (overrideCoupon) {
        attribute.push({ key: "overrideCoupon", value: overrideCoupon });
      }
      return attribute;
    }

    async processStorefrontOrder() {
      const items = await this.tranformOrderItemForStorefront();
      const payload = {
        query: `
          mutation cartCreate($input: CartInput!) {
            cartCreate(input: $input) {
              cart {
                checkoutUrl
              }
              userErrors {
                field
                message
              }
            }
          }
        `,
        variables: {
          input: {
            attributes: Object.entries(this.getCartUserAttributes(items))
              .map(([key, value]) => ({ key, value }))
              .concat(this.getOverrideCouponAttribute()),
            buyerIdentity: {
              countryCode: theme.cart.country_code,
            },
            discountCodes: this.getAutomaticCoupons(),
            lines: items,
          },
        },
      };
      const response = await apiFetchStorefront(JSON.stringify(payload));
      const errors = response.data.cartCreate.userErrors;
      if (errors.length > 0) {
        throw errors[0];
      }
      const checkoutUrl = new URL(response.data.cartCreate.cart.checkoutUrl);
      checkoutUrl.searchParams.append("locale", theme.shop.language);
      window.location.href = checkoutUrl.toString();
    }

    handleError(errData) {
      this.setLoading(false);
      const errors =
        (this.form && this.form.querySelector(".error-message")) ||
        document.getElementById("CartDrawer-CartErrors");
      errors.textContent = errData.message || window.cartStrings.submit_error;
      errors.removeAttribute("hidden");
      logger.error(`OrderCreationError: ${errData}`);
      layerPush({
        event: "orderCreationError",
        errorData: errData,
        errorContext: {
          order_payload: this.orderCreationPayload,
          currency: theme.cart.currency,
          variants: this.items && this.items.map((item) => item.variant),
          selling_plans:
            this.items &&
            this.items.map((item) =>
              item.selling_plan ? item.selling_plan : null
            ),
        },
      });
    }
    orderHasSubscription(cartItems = []) {
      return cartItems.some((item) => {
        const isSubscription =
          (item.properties && item.properties._interval) ||
          (item.properties && item.properties["_subscription-program-ids"]) ||
          item.selling_plan;
        return isSubscription;
      });
    }

    orderHasGroomingRescueProgram(cartItems = []) {
      return cartItems.some((item) => {
        return (
          item.properties &&
          item.properties["_item_type"] === "subscription_program"
        );
      });
    }

    orderIsCustomBundle() {
      return this.hasAttribute("data-bundle");
    }

    getOrderType(cartItems = []) {
      let orderType = "otp";
      const allCartItems = cartItems.concat(this.getAdditionalItems());
      if (this.orderHasSubscription(allCartItems)) {
        orderType = "recurring";
      }
      // Use for cases when we don't add the items to the cart
      const orderTypeFromAttribute = this.getAttribute("data-order-type");
      return orderTypeFromAttribute || orderType;
    }

    async parseCheckoutExperiments(currentCartAttributes) {
      for (const currentExperiment of window.checkoutExperiments) {
        if (window._gbookExp[currentExperiment.growthBookKey]) {
          try {
            currentCartAttributes = {
              ...currentCartAttributes,
              [currentExperiment.cartAttribute]: true,
            };
            await updateCart({ attributes: currentCartAttributes });
          } catch (error) {
            logger.error(`Error setting checkout Experiment to Cart: ${error}`);
            // You might want to consider whether to continue execution or return here
          }
        }
      }
      return currentCartAttributes;
    }
    async useGrowthBookExperiment(cartAttributes) {
      let currentCartAttributes = cartAttributes;
      if (!window.checkoutExperiments?.length) return;
      await this.parseCheckoutExperiments(currentCartAttributes);
    }
    getCartUserAttributes(cartItems = []) {
      return getCartUserAttributes(this.getOrderType(cartItems), [
        ...cartItems,
        ...this.getAdditionalItems(),
      ]);
    }

    shouldSkipCart() {
      return this.getAttribute("data-skip-cart") === "true";
    }

    async cleanUpCart(cartItems = this.DEFAULT_CART_ITEMS) {
      try {
        const itemsToRemove = cartItems.remove.map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: item.properties,
          selling_plan: item.selling_plan,
        }));
        const cartAttributes = Object.assign(
          {},
          cartItems.attributes,
          this.getCartUserAttributes(cartItems.add),
          {
            prevCartItems: JSON.stringify(itemsToRemove),
            prevCartCount: cartItems.count,
            shouldInitialize: itemsToRemove.length > 0,
          }
        );
        const payload = {
          updates: cartItems.remove
            .concat(cartItems.clear)
            .reduce((acc, item) => {
              acc[item.key] = 0;
              return acc;
            }, {}),
          attributes: cartAttributes,
        };
        return updateCart(payload);
      } catch (error) {
        logger.error(`Error during cart clean up: ${error}`);
      }
    }

    parseSubscriptionProgram(item) {
      const items = [];
      const {
        properties: {
          "_subscription-program-ids": programIds,
          "_subscription-program-selling-plans": sellingPlans,
        },
        quantity,
      } = item;
      if (programIds && sellingPlans) {
        const ids = programIds.split(";");
        const sellingPlansIds = sellingPlans.split(";");
        if (ids.length === sellingPlansIds.length) {
          ids.forEach((id, index) => {
            items.push({
              quantity: quantity,
              id: Number(id),
              properties: { _is_hidden: true, _type: "subscription-program" },
              selling_plan: Number(sellingPlansIds[index]),
            });
          });
        }
      }
      return items;
    }

    setGrowthbookOrderType(cartItems = []) {
      try {
        if (window.growthbookInstance) {
          window.growthbookInstance.setUserAttribute({
            "Order Type": this.getOrderType(cartItems),
          });
        }
      } catch (error) {
        logger.error(error);
      }
    }

    async appendExtraCartItemProperties(
      input = {
        cartItems: [],
        updateCart: false,
      }
    ) {
      try {
        const extraItemProperties = window.featureFlag("CART_ITEM_PROPERTIES", {
          _client_id: window.amplitude?.getDeviceId(),
        });
        if (!extraItemProperties) {
          return input.cartItems;
        }
        const updatedCartItems = input.cartItems.map((item) => ({
          ...item,
          properties: {
            ...item.properties,
            ...extraItemProperties,
          },
        }));

        if (input.updateCart) {
          const updateRequests = updatedCartItems.map((item) =>
            updateCart(
              {
                id: item.key,
                properties: item.properties,
                quantity: item.quantity,
              },
              "change"
            )
          );
          await Promise.allSettled(updateRequests);
        }

        return updatedCartItems;
      } catch (error) {
        logger.error(error);
        return input.cartItems;
      }
    }

    async processCheckout(evt) {
      try {
        evt.preventDefault();
        this.setLoading(true);
        const cartData = await apiFetchJson("", "/cart.js");
        let myBundleItems = [];
        let otherItems = [];
        let clearItems = [];
        let subscriptionProgramItems = [];
        cartData.items.forEach((item) => {
          if (item.properties && item.properties["_my-bundle"] === "true") {
            myBundleItems.push(item);
          } else if (item.properties["_is_hidden"]) {
            clearItems.push(item);
          } else if (item.properties["_subscription-program-ids"]) {
            subscriptionProgramItems = subscriptionProgramItems.concat(
              this.parseSubscriptionProgram(item)
            );
            otherItems.push(item);
          } else {
            otherItems.push(
              item.selling_plan_allocation
                ? {
                    ...item,
                    selling_plan: item.selling_plan_allocation.selling_plan.id,
                  }
                : item
            );
          }
        });
        let cartItems = {
          add: otherItems,
          remove: myBundleItems,
          clear: clearItems,
          attributes: cartData.attributes,
          count: otherItems.reduce((acc, item) => acc + item.quantity, 0),
        };
        if (this.orderIsCustomBundle()) {
          cartItems.add = myBundleItems;
          cartItems.remove = otherItems;
        }
        await this.useGrowthBookExperiment(cartData.attributes);
        this.setGrowthbookOrderType(cartItems.add);

        if (this.shouldSkipCart()) {
          await this.processStorefrontOrder();
          return;
        }
        await this.cleanUpCart(cartItems);
        await this.appendExtraCartItemProperties({
          updateCart: true,
          cartItems: cartItems.add,
        });
        if (subscriptionProgramItems.length && !this.orderIsCustomBundle()) {
          await updateCart({ items: subscriptionProgramItems }, "add");
        }
        window.location.href = window.routes.checkout;
      } catch (e) {
        this.handleError(e);
      }
    }

    load() {
      // Use the form submit event if button is placed inside a form
      if (this.form) {
        this.form.addEventListener("submit", (evt) => {
          evt.preventDefault();
          this.processCheckout(evt);
        });
      } else if (this.button) {
        this.button.addEventListener("click", (evt) => {
          evt.preventDefault();
          this.processCheckout(evt);
        });
      }
    }
  }
  customElements.define("checkout-button", CheckoutButton);
}
